import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import { ProtocolSectionAnswersBatchHttpRequestModel } from './types';
import { Fetcher } from '../fetcher';
import { ProtocolSectionAnswersBatchResult } from 'shared/dtos/out/protocolAnswer';

export class ProtocolSectionAnswersBatchRequestRunner
  implements IHttpRequestRunner
{
  constructor(private fetcher: typeof Fetcher) {}

  async execute(
    request: ProtocolSectionAnswersBatchHttpRequestModel
  ): Promise<ProtocolSectionAnswersBatchResult> {
    if (request.method !== 'PUT') {
      throw new Error(
        'ProtocolSectionAnswersBatchRequestRunner only supports PUT method'
      );
    }

    await this.fetcher.PUT(
      request.url,
      request.data.protocolSectionAnswersBatchOutDto
    );

    return {
      inspectionId: request.data.inspectionId,
      sectionId: request.data.sectionId,
      isApplicable: request.data.protocolSectionAnswersBatchOutDto.isApplicable,
      protocolItemIds: request.data.protocolItemIds,
    };
  }
}
